import type { AlertTab } from '@/schemas/alerts'

export const alertKeys = {
  all: ['alerts'] as const,
  lists: () => [...alertKeys.all, 'list'] as const,
  list: (tab: AlertTab) => [...alertKeys.lists(), tab] as const,
}
